/// <amd-module name="Pipelines/Common/Library/RestClient/Pipelines" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\client\pipelines\teamfoundation\webapi\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Pipelines from "Pipelines/Common/Library/Contracts/Pipelines";
import * as VS_Operations from "VSS/Platform/Contracts/Operations";

export interface IPipelinesRestClient extends IVssRestClient {
    /**
     * LEGACY METHOD - Obsolete Creates a new Pipeline connection between the provider installation and the specified project. Returns an Operation object that holds the redirect Url
     * 
     * @param createConnectionInputs - 
     */
    createConnection(createConnectionInputs: Pipelines.CreatePipelineConnectionInputs): Promise<VS_Operations.Operation>;
    /**
     * Creates a new Pipeline connection between the provider installation and the specified project. Returns the PipelineConnection object created.
     * 
     * @param createConnectionInputs - 
     * @param project - 
     */
    createProjectConnection(createConnectionInputs: Pipelines.CreatePipelineConnectionInputs, project: string): Promise<Pipelines.PipelineConnection>;
}

class PipelinesRestClient extends RestClientBase implements IPipelinesRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * LEGACY METHOD - Obsolete Creates a new Pipeline connection between the provider installation and the specified project. Returns an Operation object that holds the redirect Url
     * 
     * @param createConnectionInputs - 
     */
    public async createConnection(
        createConnectionInputs: Pipelines.CreatePipelineConnectionInputs
        ): Promise<VS_Operations.Operation> {

        return this.beginRequest<VS_Operations.Operation>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/pipelines/connections",
            body: createConnectionInputs
        });
    }

    /**
     * Creates a new Pipeline connection between the provider installation and the specified project. Returns the PipelineConnection object created.
     * 
     * @param createConnectionInputs - 
     * @param project - 
     */
    public async createProjectConnection(
        createConnectionInputs: Pipelines.CreatePipelineConnectionInputs,
        project: string
        ): Promise<Pipelines.PipelineConnection> {

        const queryValues: any = {
            project: project
        };

        return this.beginRequest<Pipelines.PipelineConnection>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/pipelines/connections",
            queryParams: queryValues,
            body: createConnectionInputs
        });
    }

}

export const PipelinesClientName = "CIX.IPipelinesRestClient";

export function getPipelinesClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IPipelinesRestClient {
    return pageContext.getRestClient<IPipelinesRestClient>(PipelinesClientName, options);
}

RestClients.add(PipelinesClientName, { 
    factory: PipelinesRestClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
